import type { IconSvgObject } from './types';

const PinLocation03Icon: IconSvgObject = [
  ["circle", { cx: "12", cy: "6", r: "4", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 16C3.7492 16.6327 3 17.4385 3 18.3158C3 20.3505 7.02944 22 12 22C16.9706 22 21 20.3505 21 18.3158C21 17.4385 20.2508 16.6327 19 16", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 10L12 18", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export default PinLocation03Icon;
